import { usePage } from '@inertiajs/react';

import BookingFormProps from '../types/pageProps/BookingFormProps';

const useBookingFormProps = () => {
    const { props } = usePage<BookingFormProps>();

    return props as BookingFormProps;
};

export default useBookingFormProps;
